import { Button, Image, UIText1, UIText3 } from '@cian/ui-kit';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './footer.css';

interface IFooterProps {
  authorName?: string | null;
  authorLogoUrl?: string | null;
  authorLabel: string;
  isDescriptionModal: boolean;
  handleOpenContactModal?(): void;
}

export const Footer = ({
  authorName,
  authorLogoUrl,
  authorLabel,
  isDescriptionModal,
  handleOpenContactModal,
}: IFooterProps) => {
  return (
    <div
      className={cx(styles['footer'], {
        [styles['footer']]: isDescriptionModal,
        [styles['footer-isdescriptionmodal']]: !isDescriptionModal,
      })}
    >
      <div
        className={cx(styles['footer-contact'], {
          [styles['footer-contact']]: isDescriptionModal,
          [styles['footer-contact-isdescriptionmodal']]: !isDescriptionModal,
        })}
      >
        {authorLogoUrl && (
          <div className={styles['logo']}>
            <Image src={authorLogoUrl} borderRadius="4px" objectFit="contain" />
          </div>
        )}
        <div className={styles['description']}>
          <UIText3 color="gray60_100">{authorLabel}</UIText3>
          {authorName && <UIText1>{authorName}</UIText1>}
        </div>
      </div>
      {isDescriptionModal && (
        <div>
          <Button
            onClick={handleOpenContactModal}
            size="M"
            theme="fill_primary"
            type="button"
            beforeIcon={<IconCommunicationPhone16 color="icon-inverted-default" />}
          >
            Узнать у застройщика
          </Button>
        </div>
      )}
    </div>
  );
};
